import React, { useState } from 'react';
import { TextField } from '@scale/scaleui';
import BuilderHint from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderHint';
import { isNil as _isNil, isEmpty as _isEmpty } from 'lodash';

const NumberInput: React.FC<{
  value: number | undefined;
  setValue: (value: number | undefined) => void;
  min?: number;
  max?: number;
  step?: number;
  hint?: string;
}> = ({ value, setValue, min, max, step, hint }) => {
  const [displayValue, setDisplayValue] = useState<string>(_isNil(value) ? '' : String(value));
  const handleChange = (value: string) => {
    if (_isEmpty(value)) {
      setValue(undefined);
      return;
    }
    const newValue = Number(value);
    if (!_isNil(min) && newValue < min) {
      setValue(min);
      setDisplayValue(String(min));
      return;
    }
    if (!_isNil(max) && newValue > max) {
      setValue(max);
      setDisplayValue(String(max));
      return;
    }
    setValue(newValue);
    setDisplayValue(String(newValue));
  };
  return (
    <div className="flex">
      <TextField
        value={displayValue}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDisplayValue(e.target.value)}
        onBlur={() => handleChange(displayValue)}
        step={step}
        type="number"
      />
      {hint && <BuilderHint name="NumberInput" hint={hint} />}
    </div>
  );
};

export default NumberInput;
